import { create } from 'zustand';
import { ADDITIONAL_TYPE } from '../enums/additionalTypeEnum';
import { AutVrfAddActivateResponse } from '../types/api/autVrfAddActivate';

interface SelectedARSTelNo {
  telNo: string;
  maskTelNo: string;
}

interface AdditionalState {
  // status: string;
  // setStatus: (s: string) => void;
  // isLoading: () => boolean;
  // isSuccess: () => boolean;
  activateInfo: AutVrfAddActivateResponse | null;
  setActivateInfo: (res: AutVrfAddActivateResponse) => void;
  step: number;
  subStep: number;
  setStep: (n: number | ((prev: number) => number)) => void;
  setSubStep: (n: number | ((prev: number) => number)) => void;
  currentAdditionalType: string;
  setCurrentAdditionalType: (s: string) => void;
  selectedARSTelNo: SelectedARSTelNo | null;
  setSelectedARSTelNo: (res: SelectedARSTelNo | null) => void;
  reset: () => void;
  isSimple: () => boolean;
  isIdentify: () => boolean;
  isARS: () => boolean;
  isOverseasDeparture: () => boolean;
}

export const useAdditionalStore = create<AdditionalState>((set, get) => ({
  // status: 'idle',
  // setStatus: (s) => set({ status: s }),
  // isLoading: () => {
  //     return get().status != 'success';
  // },
  // isSuccess: () => {
  //     return get().status == 'success';
  // },
  activateInfo: null,
  setActivateInfo: (res) =>
    set({
      activateInfo: res,
    }),
  step: 0,
  subStep: 0,
  setStep: (n) => set((state) => ({ step: typeof n === 'function' ? n(state.step) : n })),
  setSubStep: (n) => set((state) => ({ subStep: typeof n === 'function' ? n(state.subStep) : n })),
  currentAdditionalType: '',
  setCurrentAdditionalType: (s) => set({ currentAdditionalType: s }),
  selectedARSTelNo: null,
  setSelectedARSTelNo: (res) =>
    set({
      selectedARSTelNo: res,
    }),
  reset: () =>
    set({
      activateInfo: null,
      step: 0,
      subStep: 0,
      currentAdditionalType: '',
      selectedARSTelNo: null,
    }),
  isSimple: () => {
    const { activateInfo } = get();

    if (!activateInfo?.additionalType) return false;

    return activateInfo.additionalType.includes(ADDITIONAL_TYPE.SIMPLE);
  },
  isIdentify: () => {
    const { activateInfo } = get();

    if (!activateInfo?.additionalType) return false;

    return activateInfo.additionalType.includes(ADDITIONAL_TYPE.IDENTIFY);
  },
  isARS: () => {
    const { activateInfo } = get();

    if (!activateInfo?.additionalType) return false;

    return activateInfo.additionalType.includes(ADDITIONAL_TYPE.ARS);
  },
  isOverseasDeparture: () => {
    const { activateInfo } = get();

    if (!activateInfo?.additionalType) return false;

    return activateInfo.additionalType.includes(ADDITIONAL_TYPE.OVERSEAS_DEPARTURE);
  },
}));
